<template>
  <b-card-code>

    <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="success"
        v-on:click="addUsina()"
      >
        Adicionar
    </b-button>

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Pesquisar</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Pesquisar"
            type="text"
            class="d-inline-block"
            @input="handleSearch"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <b-overlay
        :show="(loading || selectLoading)"
        rounded="sm"
        no-fade
      >

      <vue-good-table
        mode="remote"
        :totalRows="totalRecords"
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm
        }"
        :pagination-options="{
          enabled: true,
        }"
        @on-sort-change="onSortChange"
      >

        <div slot="emptystate">
          Nenhum resultado encontrado.
        </div>

        <template
          slot="table-row"
          slot-scope="props"
        >

        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item v-on:click="editUsina(props.row.alias)">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Editar</span>
              </b-dropdown-item>
              <b-dropdown-item v-on:click="editUsinaInfo(props.row.id)">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Informações</span>
              </b-dropdown-item>

              <b-dropdown-item v-on:click="delUsina(props.row.nome, props.row.alias)">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Deletar</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

      </template>

        <!-- pagination -->
        <template
          slot="pagination-bottom"
          slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                Exibindo 1 de
              </span>
              <b-form-select
                v-model="pageLength"
                :options="['10','25','50']"
                class="mx-1"
                @input="handlePageChange"
              />
              <span class="text-nowrap"> de {{ props.total }}.</span>
            </div>
            <!-- pagination -->
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @change="handleChangePage"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </b-overlay>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BAvatar, BOverlay, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BButton
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import Ripple from 'vue-ripple-directive'
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BAvatar,
    BOverlay,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      pageLength: 20,
      dir: false,
      columns: [
        {
          label: 'Nome',
          field: 'nome',
        },
        {
          label: 'CNPJ',
          field: 'cnpj',
        },
        {
          label: 'Opções',
          field: 'action',
        },
      ],
      rows: [],
      totalRecords: 0,
      searchTerm: '',
      sortType: 'desc',
      sortField: 'id',
      page: 1,
      loading: false,
      urlImg: process.env.VUE_APP_URL_LOGO_GRUPOS
    }
  },
  computed: {
    ...mapGetters([
      'selectLoading',
    ]),
    direction() {
      if(store.state.appConfig.isRTL){
        this.dir = true;
        return this.dir;
      }
      this.dir = false;
      return this.dir;
    },
  },
  async created() {
    const params = {
      pageLength: this.pageLength
    };
    this.loading = true;
    await useJwt.request('/api/usina', params).then(request => {
      this.rows = request.data.data;
      this.totalRecords = request.data.totalRecords;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  },
  methods: {
    editUsina(alias) {
      this.$router.replace(`/usina/editar/${alias}`);
    },

    editUsinaInfo(id) {
      this.$router.replace(`/usina/editar/info/${id}`);
    },

    addUsina() {
      this.$router.replace(`/usina/adicionar`);
    },

    delUsina(nome, alias) {
      Swal.fire({
        title: 'Deletar?',
        html: `Você tem certeza que deseja deletar a usina <strong>${nome}</strong>?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, deletar!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.isConfirmed) {

          this.loading = true;
          await useJwt.request('/api/usina/del', {alias: alias}).then(request => {
            this.loading = false;

            Swal.fire({
              icon: request.data.status == 'success' ? 'success' : 'danger',
              title: request.data.status == 'success' ? 'Deletado!' : 'Erro!',
              text: request.data.msg,
              allowOutsideClick: false,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            }).then(resultConfirm => {              
              if (resultConfirm.value) {
                this.$router.go(0);
              }
            });
            
          }).catch(() => {
            this.loading = false;
          });
        
        }
      })
    },

    handleSearch(searchTerm) {
        this.searchTerm = searchTerm;
        this.loadItems({
          searchTerm: this.searchTerm
        });
    },

    handleChangePage(page) {
      this.page = page;
      this.loadItems({
          page: this.page,
      });
    },

    handlePageChange(active) {
      this.pageLength = active;
      this.loadItems({
        pageLength: this.pageLength,
      });
    },

    onSortChange(params) {
      this.sortType = params[0].type;
      this.sortField = params[0].field;
      this.loadItems({
          type: this.sortType,
          field: this.sortField,
      });
    },

    // load items is what brings back the rows from server
    async loadItems(params) {
      params.pageLength = this.pageLength;
      params.searchTerm = this.searchTerm;
      params.type = this.sortType;
      params.field = this.sortField;
      params.page = this.page;

      this.loading = true;
      await useJwt.request('/api/usina', params).then(request => {
        this.rows = request.data.data;
        this.totalRecords = request.data.totalRecords;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    }
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>